<template lang="pug">
.card.market-card
  .card-header.bg-more-head.collapse-more(
    :id="'heading-htft-' + id"
    data-toggle='collapse'
    :data-target="'#collapse-htft-' + id"
    :aria-controls="'collapse-htft-' + id"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $tc("m.BT_HTFT", 1) }}
  .collapse.show(
    :aria-labelledby="'heading-htft-' + id"
    :id="'collapse-htft-' + id"
  )
    .card-body.p-0
      .market-card-content
        .three-column
          .three-column-content
            .three-column-group
              .three-column-odd-area
                .three-column-odd-area-oddtype
                  p.mb-0 {{ $t("m.BT_HH") }}
                .three-column-odd-area-group
                  template(v-if="moreItems['htfto']['HH'] && moreItems['htfto']['HH'][5] != 0 && moreItems['htfto']['HH'][5] != ''")
                    OddsItem(:odds="moreItems['htfto']['HH'] " idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
              .three-column-odd-area
                .three-column-odd-area-oddtype
                  p.mb-0 {{ $t("m.BT_HD") }}
                .three-column-odd-area-group
                  template(v-if="moreItems['htfto']['HD'] && moreItems['htfto']['HD'][5] != 0 && moreItems['htfto']['HD'][5] != ''")
                    OddsItem(:odds="moreItems['htfto']['HD'] " idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
              .three-column-odd-area
                .three-column-odd-area-oddtype
                  p.mb-0 {{ $t("m.BT_HA") }}
                .three-column-odd-area-group
                  template(v-if="moreItems['htfto']['HA'] && moreItems['htfto']['HA'][5] != 0 && moreItems['htfto']['HA'][5] != ''")
                    OddsItem(:odds="moreItems['htfto']['HA'] " idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
            .three-column-group
              .three-column-odd-area
                .three-column-odd-area-oddtype
                  p.mb-0 {{ $t("m.BT_DH") }}
                .three-column-odd-area-group
                  template(v-if="moreItems['htfto']['DH'] && moreItems['htfto']['DH'][5] != 0 && moreItems['htfto']['DH'][5] != ''")
                    OddsItem(:odds="moreItems['htfto']['DH'] " idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
              .three-column-odd-area
                .three-column-odd-area-oddtype
                  p.mb-0 {{ $t("m.BT_DD") }}
                .three-column-odd-area-group
                  template(v-if="moreItems['htfto']['DD'] && moreItems['htfto']['DD'][5] != 0 && moreItems['htfto']['DD'][5] != ''")
                    OddsItem(:odds="moreItems['htfto']['DD'] " idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
              .three-column-odd-area
                .three-column-odd-area-oddtype
                  p.mb-0 {{ $t("m.BT_DA") }}
                .three-column-odd-area-group
                  template(v-if="moreItems['htfto']['DA'] && moreItems['htfto']['DA'][5] != 0 && moreItems['htfto']['DA'][5] != ''")
                    OddsItem(:odds="moreItems['htfto']['DA'] " idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
            .three-column-group
              .three-column-odd-area
                .three-column-odd-area-oddtype
                  p.mb-0 {{ $t("m.BT_AH") }}
                .three-column-odd-area-group
                  template(v-if="moreItems['htfto']['AH'] && moreItems['htfto']['AH'][5] != 0 && moreItems['htfto']['AH'][5] != ''")
                    OddsItem(:odds="moreItems['htfto']['AH'] " idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
              .three-column-odd-area
                .three-column-odd-area-oddtype
                  p.mb-0 {{ $t("m.BT_AD") }}
                .three-column-odd-area-group
                  template(v-if="moreItems['htfto']['AD'] && moreItems['htfto']['AD'][5] != 0 && moreItems['htfto']['AD'][5] != ''")
                    OddsItem(:odds="moreItems['htfto']['AD'] " idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
              .three-column-odd-area
                .three-column-odd-area-oddtype
                  p.mb-0 {{ $t("m.BT_AA") }}
                .three-column-odd-area-group
                  template(v-if="moreItems['htfto']['AA'] && moreItems['htfto']['AA'][5] != 0 && moreItems['htfto']['AA'][5] != ''")
                    OddsItem(:odds="moreItems['htfto']['AA'] " idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  }
}
</script>